
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,

  SET_SOILS: (state, payload) => state.soils = payload,
}